<template>
    <div class="row">
        <div class="col-md-7">
            <div class="p-3 bg-white shadow-sm rounded-lg mb-3">
                <h5 class="font-weight-bold text-info">Refund</h5>

                <div v-if="refunds.length" class="p-2 border rounded mb-3 font-weight-bold text-success border-success">
                    The details for the existing refund record(s) related to this request are as follows
                </div>

                <table class="table table-sm table-bordered">
                    <thead class="bg-light">
                    <tr>
                        <th>Created</th>
                        <th>Reference</th>
                        <th>Status</th>
                        <th class="text-right">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="i in refunds" :key="i.id">
                        <td>{{ day(i.created_at).format('DD/MM/YY') }}</td>
                        <td><a href="#" @click="editRefund(i)">{{ i.reference }}</a></td>
                        <td><span :class="'status ' + i.status">{{ i.status }}</span></td>
                        <td class="text-right">{{ i.currency }} {{ i.amount }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="p-3 bg-white shadow-sm rounded mb-2">

                <alerts :_success="success" :_error="error"></alerts>

                <form @submit.prevent="createRefund()">
                    <div class="form-group row">
                        <label class="col-md-4"></label>
                        <div class="col-md-7">
                            <h5 class="font-weight-bold text-info">Create Refund</h5>
                            Request Code {{ request.code }}
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="amount" class="col-md-4 col-form-label text-md-right">Refund Amount</label>
                        <div class="col-md-7">
                            <input type="number" id="amount" class="form-control mb-2" v-model="refund.amount"
                                   min=".50"
                                   :max="request.amount" step=".01"
                                   placeholder="Refund amount" :disabled="wait || !candEdit" required>
                            <span class="text-muted">Refund Amount, do not use commas or spaces</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="reference" class="col-md-4 col-form-label text-md-right">Currency</label>
                        <div class="col-md-7">
                            <select id="currency" class="form-control mb-2" v-model="refund.currency"
                            :disabled="wait || !candEdit" required>
                                <option>USD</option>
                                <option>KES</option>
                        </select>
                        <span class="text-muted">
                        Amount will be converted to USD <br>
                        Base rate (100)</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="reference" class="col-md-4 col-form-label text-md-right">Reference No</label>
                        <div class="col-md-7">
                            <input type="text" id="reference" class="form-control mb-2" placeholder="Reference number"
                                   v-model="refund.reference" required :disabled="wait || !candEdit">
                            <span class="text-muted">M-Pesa Reference Number</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="reference" class="col-md-4 col-form-label text-md-right">Transaction Date</label>
                        <div class="col-md-7">
                            <Datepicker id="expected_date" :bootstrap-styling="true" :disabledDates="disabledDates"
                                        class="mb-2" v-model="refund.date" maximum-view="day"
                                        :disabled="wait || !candEdit"
                                        placeholder="Select date" :required="true"></Datepicker>
                            <span class="text-muted">M-Pesa Reference Number</span>
                        </div>
                    </div>

                    <div v-if="canEdit()" class="form-group row">
                        <label class="col-md-4"></label>
                        <div class="col-md-7">
                            <button type="submit" class="btn btn-success mr-1" :disabled="wait">
                                <span v-if="wait">Please wait...</span>
                                <span v-else>
                                    <template v-if="refund.id">Update Refund</template>
                                    <template v-else>Create Refund</template>
                                </span>
                            </button>
                            <button class="btn btn-outline-secondary" @click.prevent="reset()">Cancel</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
        <div class="col-md-5">
            <div v-if="request" class="p-3 bg-white shadow-sm rounded mb-2">
                <h5 class="font-weight-bold text-info">Request</h5>
                <span class="h6 font float-right text-success">USD {{ request.amount }}</span>
                <p class="text-muted">{{ day(request.created_at).format('MMM, DD YYYY H:mm') }}</p>
                <p>Reference No: {{ request.code }}</p>
                <p>{{ request.title }}</p>
            </div>

            <div class="p-3 bg-white shadow-sm rounded mb-2">
                <h5 class="font-weight-bold text-info">Remittance</h5>
                <p>
                    All remaining money after expenditure to be remitted back to the bank <br>
                    Please use the following MPESA Paybill and account
                </p>
                <p>
                    Paybill: <b>880100</b> <br>
                    Account No: <b>8137450018</b>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Alerts from "./Alerts";

export default {
    name: "Refund",
    props: ['code'],
    components: {Alerts, Datepicker},
    data() {
        return {
            request: {},
            refunds: [],
            refund: {
                id: '',
                amount: '',
                currency: '',
                reference: '',
                date: new Date()
            },
            disabledDates: {},
        }
    },
    mounted() {
        this.loadRequest()
        this.loadRefunds()
    },
    computed: {
        candEdit() {
            return !this.refund.id || this.refund.status == 'pending'
        },
    },
    methods: {
        editRefund(refund) {
            this.refund = refund
        },
        loadRequest() {
            this.$http.get('/request/' + this.code).then(response => {
                this.request = response.data.data
            })
        },
        loadRefunds() {
            this.$http.get('/refunds/' + this.code).then(response => {
                this.refunds = response.data.data
            })
        },
        canEdit() {
            if (!this.refund.id) {
                return true
            }
            return this.refund.status == 'pending' ? true : false
        },
        reset() {
            this.refund = {
                id: '',
                amount: '',
                currency: 'USD',
                reference: '',
                date: new Date()
            }
        },
        createRefund() {
            this.setLoading()
            this.clear()
            this.refund.request_id = this.id
            this.$http.post(`/refunds/${this.code}`, this.refund).then(() => {
                this.success = "Refund saved successfully"
                this.reset()
                this.loadRefunds()
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<style scoped>

</style>